<!-- 质量管理 圆环图 -->
<template>
  <div style="height:100%;width:100%">
    <div class="chart-wrapper">
      <div class="chart-content" :id="chartID"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["chartOption","contentShow"],
  data() {
    return {
      chartID: this.uuid(),
      screenshots:'',
      timer:true
    };
  },
  computed: {},
  created() {},
  watch: {
    chartOption: function () {
    const echarts = require("echarts");
    this.$nextTick(()=> {
      this.myChart = echarts.init(document.getElementById(this.chartID));
      this.setChart();
      if(!this.contentShow) return
      setTimeout(()=>{
        if(this.timer){
          this.screenshots = new Image();
          this.screenshots.src = this.myChart.getConnectedDataURL({
              pixelRatio: 1,
          });
          this.screenshots.sizes=1024
          this.$emit('childLine',this.screenshots)
          console.log('倒计时截图')
        }
      },5000)
      this.myChart.on('rendered',()=>{
        this.timer=false
      })
      this.myChart.on('finished',()=>{
        this.screenshots = new Image();
        this.screenshots.src = this.myChart.getConnectedDataURL({
            pixelRatio: 1,
        });
        this.$emit('childLine',this.screenshots)
      })
    }); 
      console.log("this.heartmapchartOption", this.chartOption);
    },
  },
  mounted() {
    
  },
  methods: {
    setChart() {
      const option = Object.assign(
        {
          tooltip: {
            position: "top",
          },
          animation: false,
          grid: {
            height: "70%",
            top: "10%",
          },
        },
        this.chartOption
      );
      this.myChart.setOption(option);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped="">
.chart-wrapper,
.chart-content {
  height: 100%;
  width: 100%;
}
</style>